import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-48" data-mp="e3didugelir3">
      <div className="mx-auto max-w-5xl" data-id="element-49" data-mp="9cszrbcd83e">
        <div className="mx-auto max-w-3xl text-center" data-id="element-50" data-mp="8bch7bk3tea">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-51" data-mp="57xr9l719hp7">
            Une meilleure façon d&apos;enseigner les Arts Plastiques
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-navy sm:text-5xl" data-id="element-52" data-mp="3rgpa66c85ljb">
            De l&apos;enseignant débordé au{' '}
            <span className="italic text-grape" data-id="element-53" data-mp="3ifr5rmxvjc07">guide serein.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-navy/60 sm:text-base" data-id="element-54" data-mp="3ihv7pzc7q0xu">
            ARTS PRÊT™ transforme des heures de planification épuisantes en un
            système « ouvrez et enseignez ». Arrivez à chaque cours avec un plan
            clair, des activités qui enchantent les élèves et la confiance de
            celui qui maîtrise tout.
          </p>
        </div>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-55" data-mp="1f7hc1hp6lxnj">
          <div className="grid md:grid-cols-2" data-id="element-56" data-mp="1t070rtw3hgoc">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-57" data-mp="1o1dna1gt5po6">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy/35" data-id="element-58" data-mp="1o3yrgx4kwhp3">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-59" data-mp="wb7qk9bya4ti" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-navy/40" data-id="element-60" data-mp="1aa7ipqyo91uf">
                Le coût de repartir de zéro chaque jour
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-61" data-mp="15dgz4tnnro49">
                L&apos;ANCIENNE MÉTHODE
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-62" data-mp="2gprmulnjou1u">
                Fatigante, improvisée, jamais finie.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-63" data-mp="2ssucdiip7htz">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white/80 px-4 py-3 text-sm text-navy/60" data-id="element-64" data-mp="2xrxfgxf4bdzb">
                    <CircleXIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy/30" aria-hidden="true" data-id="element-65" data-mp="32oxj71ohw4n9" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-66" data-mp="2f0nvtvbmv8u0">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-teal text-white" data-id="element-67" data-mp="2jsnz9xqwwjvc">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-68" data-mp="1mbyxg41yphly" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-teal" data-id="element-69" data-mp="1rak0sccighem">
                Le système ARTS PRÊT™
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-70" data-mp="1et98by6kwje3">
                VOTRE NOUVELLE RÉALITÉ
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-71" data-mp="19sbhyybf0j1i">
                Planifiez moins, enseignez mieux.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-72" data-mp="10tzuv69rc3dt">
                {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-navy-light px-4 py-3 text-sm font-medium text-navy" data-id="element-73" data-mp="w31b1wpk8n5t">
                    <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-74" data-mp="m4twfkiquh6z" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-navy/5 bg-cream px-6 py-4 text-center text-xs text-navy/50" data-id="element-75" data-mp="d69n39z2pjvf">
            Un système complet pour planifier moins et enseigner avec plus de
            sens.
          </p>
        </div>
      </div>
    </section>;
}